import React, { useContext } from "react";
import { Context } from "../../context";
import classes from "./Project.module.css";

const LatestSiteCard = ({ image, domain, url }) => {
    const { lang } = useContext(Context);

    return (
        <div className="col-12 col-md-6 col-lg-4 px-4 mb-4 d-flex align-items-stretch">
            <div className={`${classes.projectCard} h-100`}>
                {/* BASH HEADER */}
                <div className={classes.titleBarLight}>
                    <div className={classes.dots}>
                        <div className={`${classes.dot} ${classes.dotRed}`}></div>
                        <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                        <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                    </div>
                    <div className={classes.tabLight}>
                        {domain}.js
                    </div>
                </div>

                {/* Image */}
                <div className={classes.projectImgContainer}>
                    <img
                        src={image}
                        alt={domain}
                        style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                        }}
                    />
                </div>

                {/* Domain and Link */}
                <div className={`${classes.projectTextContainer} d-flex flex-column flex-grow-1`}>
                    <div className={classes.titleContainer}>
                        <div className={classes.projectUrl}>{domain}</div>
                    </div>
                    <div className="mt-auto text-right">
                        <a
                            href={url.startsWith("http") ? url : `https://${url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-dark"
                            style={{ fontSize: '14px', padding: '5px 15px' }}
                        >
                            {lang === "en" ? "Visit site" : "Visita sito"}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LatestSiteCard;
